import { render, staticRenderFns } from "./ByImageForm.vue?vue&type=template&id=80e137ac&"
import script from "./ByImageForm.vue?vue&type=script&lang=js&"
export * from "./ByImageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports